
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/25th-anniversary",
      function () {
        return require("private-next-pages/25th-anniversary.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/25th-anniversary"])
      });
    }
  